import type { JSONContent } from '@tiptap/react';
import { DateUtils } from '../DateUtils';
import { ArticleDraftRequest } from '../../api/queries';

const initialArticle: JSONContent = {
  type: 'doc',
  content: [
    {
      type: 'heading',
      attrs: {
        textAlign: null,
        level: 1,
      },
      content: [
        {
          type: 'text',
          text: 'Artikkel',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'Bytt ut dette innholdet med ditt innhold! ',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        textAlign: null,
      },
    },
  ],
};

export class ArticleUtils {
  public static initialArticle = initialArticle;

  public static jsonEqual = (
    a: Record<string, any>,
    b: Record<string, any>,
  ) => {
    function canonicalize(obj: Record<string, any>): Record<string, any> {
      if (Array.isArray(obj)) {
        return obj.map(canonicalize);
      } else if (obj && typeof obj === 'object') {
        return Object.keys(obj)
          .sort()
          .reduce((acc: any, key) => {
            acc[key] = canonicalize(obj[key]);
            return acc;
          }, {});
      }
      return obj;
    }

    return JSON.stringify(canonicalize(a)) === JSON.stringify(canonicalize(b));
  };

  public static isJsonContentEmpty = (json: JSONContent) => {
    const emptyJsonContent: JSONContent = {
      type: 'doc',
      content: [
        {
          type: 'paragraph',
          attrs: {
            textAlign: null,
          },
        },
      ],
    };

    return this.jsonEqual(json, emptyJsonContent);
  };

  public static updatedAtDateString = (date: Date) => {
    return `${DateUtils.getShortDateFromDate(date)} - ${DateUtils.getClockTimeFromDate(date, true)}`;
  };

  public static resetArticle = (): ArticleDraftRequest => {
    return {
      title: '',
      isDraft: true,
      draftId: 0,
      coverImageUrl: '',
      coverImageAlt: '',
      jsonContent: ArticleUtils.initialArticle,
      isGlobalGuide: false,
      labels: [],
      updatedAt: new Date(),
    };
  };
}
